import React from 'react'
import moment from 'moment-timezone'
import { Box, Typography } from '@material-ui/core'
import PopUp from '../../elements/popup'
import { AppButton } from '../../Components'
import { useStyles } from './styles'
import Icon from '../../utils/icons'

function EndEventPopup(props) {
  const classes = useStyles()
  const eventLeadTime = props?.programDetails?.feature_flags ? Math.floor(props?.programDetails?.feature_flags?.event_lead_time / 60) : 15
  const handleClosePopup = () => {
    props.handleClosePopup()
  }

  const handleClickYes = () => {
    handleClosePopup()
    props.cancelEvent()
  }

  const handleClickNo = () => {
    handleClosePopup()
  }

  const shouldBlockCancel = () => {
    const currentTime = moment().tz(props.timeZone)
    const timeLimit = moment(props.eventStartTime).tz(props.timeZone).subtract(eventLeadTime + 1, 'minutes')

    return timeLimit.isSameOrBefore(currentTime)
  }

  const renderPopupContent = () => (
    !props.isOngoing && shouldBlockCancel()
      ? (
        <Box className={classes.endEventPopWrapper}>
          <Box className={classes.icon}><Icon src="bigClose" /></Box>
          <Typography className={classes.infoContent}>
            {`Event cannot be cancelled in the last ${eventLeadTime} minute(s) before the scheduled start time.`}
          </Typography>
          <Typography className={classes.infoNote}>In future, cancel an event within sufficient time prior to event start</Typography>
          <Box className={classes.infoButton}>
            <AppButton text="OK, I UNDERSTAND" onClick={handleClickNo} />
          </Box>
        </Box>
      )
      : (
        <Box className={classes.endEventPopWrapper}>
          <Typography className={classes.popupContent}>
            <b>
              {
                props.isOngoing
                  ? 'Are you sure you want to end the ongoing event?'
                  : 'Are you sure you want to cancel the upcoming event?'
              }
            </b>
          </Typography>
          <Box className={classes.buttonGroup}>
            <AppButton text="Yes" onClick={handleClickYes} />
            <AppButton text="No" fill={false} onClick={handleClickNo} />
          </Box>
        </Box>
      )
  )

  return (
    <PopUp
      open={props.open}
      handleClose={props.handleClosePopup}
      content={renderPopupContent()}
      disableBackdropClick
    />
  )
}

EndEventPopup.default = {
  open: false,
  handleClosePopup: () => { },
  cancelEvent: () => { }
}

export default EndEventPopup
